import { geomGetAllocator } from "./mem";

export type PolyLine2 = Float64Array<ArrayBuffer>;
export const PolyLine2 = Float64Array;
export type PolyLine2Polygon = PolyLine2[];
export type PolyLine2MultiPolygon = PolyLine2Polygon[];
export type LineAnchor = "START" | "END" | "CENTER";
export enum LineAnchorEnum {
  START = "START",
  END = "END",
  CENTER = "CENTER",
}
export function polyLine2New(size: number | ArrayLike<number>): PolyLine2 {
  const alloc = geomGetAllocator();

  if (typeof size === "number") {
    return alloc.allocFloat64(size) as PolyLine2;
  }

  const v = alloc.allocFloat64(size.length);
  v.set(size, 0);
  return v as PolyLine2;
}
